import { Controller } from "@hotwired/stimulus";
import Axios from "axios";
import { flashDanger, uploadSizeError } from "../lib/flash";

const API_PATH = "/api/attachments/";

export default class extends Controller {
  connect() {
    this.pendingUploads = 0;
    this.element.addEventListener(
      "trix-attachment-add",
      this.uploadFileAttachment.bind(this)
    );
  }

  uploadFileAttachment(event) {
    if (!event.attachment.file) return;

    const tooLarge = uploadSizeError(event.attachment.file, this.element);
    if (tooLarge) {
      event.attachment.remove();
      flashDanger(tooLarge);
      return;
    }

    this.trackUpload(
      this.uploadFile(event.attachment).catch(() => {
        event.attachment.remove();
        flashDanger(this.element.dataset.uploadFailedMessage);
      })
    );
  }

  // Save must stay disabled from the moment an upload starts until every in-flight
  // upload has settled (finished, errored, or been rejected for size) — track a count
  // rather than a boolean since Trix allows adding several attachments at once.
  trackUpload(promise) {
    this.pendingUploads += 1;
    this.toggleSaveButton();

    promise.finally(() => {
      this.pendingUploads -= 1;
      this.toggleSaveButton();
    });
  }

  toggleSaveButton() {
    const button = this.element.closest("form")?.querySelector('[type="submit"]');
    if (button) button.disabled = this.pendingUploads > 0;
  }

  async uploadFile(attachment) {
    const response = await Axios.post(API_PATH, {
      data: {
        filename: attachment.file.name,
        size: attachment.file.size,
        content_type: attachment.file.type,
      },
    });

    const formData = new FormData();
    Object.entries(response.data.fields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", attachment.file);

    const result = await Axios({
      url: response.data.url,
      method: "POST",
      data: formData,
      onUploadProgress: (event) => {
        var progress = (event.loaded / event.total) * 100;
        attachment.setUploadProgress(progress);
      },
    });

    attachment.setAttributes({
      sgid: response.data.sgid,
      url: API_PATH + response.data.id,
      href: API_PATH + response.data.id,
    });

    return result;
  }
}
